import script from "./HomeFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeFooter.vue?vue&type=script&lang=ts&setup=true"

import "./HomeFooter.vue?vue&type=style&index=0&id=1520dbac&lang=css"

const __exports__ = script;

export default __exports__